module.exports = __webpack_public_path__ + "static/media/Flood_Warning_small.ba84185f.png";